import React, { useState, useEffect, ChangeEvent } from 'react';
import { compensation } from '../../../../Api/apiUtils';
import { MixpanelEvents, trackEvent } from '../../../../utils/mixpanelTracking';
import { Page, PageHeader, Card, Button, Field, Select, TextInput } from '../../../../ui';
import './reports.scss';




const TeacherCompensationReport = () => {
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
  
    const [email, setEmail] = useState('');
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [dayArray, setDayArray] = useState<string[]>([]);

    const monthArray = [{name :'January', id:'01', day : '16 - 31'},
    {name :'February', id:'02', day : '16 - 28'},
    {name :'March', id:'03' , day : '16 - 31'},
    {name :'April', id:'04', day : '16 - 30'},
    {name :'May', id:'05', day : '16 - 31'}, 
    {name :'June', id:'06', day : '16 - 30'}, 
    {name :'July', id:'07', day : '16 - 31'}, 
    {name :'August', id:'08', day : '16 - 31'}, 
    {name :'September', id:'09', day : '16 - 30'},
    {name :'October', id:'10', day : '16 - 31'}, 
    {name :'November', id:'11', day : '16 - 30'}, 
    {name :'December', id:'12', day : '16 - 31'}];

    useEffect(() => {
        setDayArray(dayArray); // Update day array when year or month changes
    }, [year, month]);

    const handleSelectChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = event.target;
        if (name === 'year') {
            setYear(value);
            updateDaysForMonth(month, value);
        } else if (name === 'month') {
            setMonth(value);
            updateDaysForMonth(value, year);
        } else if (name === 'day') {
            setDay(value);
        } else if (name === 'email') {
            setEmail(value);
        }
    };

    const updateDaysForMonth = (month: string, year: string) => {
        if (month === '02' && year === '2024') {
            setDayArray(['01 - 15', '16 - 29']);
        } else {
            const selectedMonth = monthArray.find(m => m.id === month);
            const day = selectedMonth?.day || 'N/A'; 
            setDayArray(['01 - 15', day]);
        }
    };
    


    const handleSubmit = async () => {
        setDisabledBtn(true);
        try {
            const fdate = `${year}/${month}/${day.split('-')[0].trim()}`;
            const ldate = `${year}/${month}/${day.split('-')[1].trim()}`;
            
            const response = await compensation(fdate, ldate, email);
    
            console.log("API Response:", response);
            alert(response.data);
            trackEvent(MixpanelEvents.TEACHER_COMPENSATION_REPORT_REQUESTED, {
              fromDateDisplay: `${year}-${month}-${day}`,
              emailDomain: email?.includes('@') ? email.split('@')[1] : undefined,
            });
        } catch (error) {
            console.error("API Error:", error);
            trackEvent(MixpanelEvents.TEACHER_COMPENSATION_REPORT_FAILED, {});
        } finally {
            setDisabledBtn(false);
        }
    };
    

    const clearForm = () => {
        setYear('');
        setMonth('');
        setDay('');
        setEmail('');
    };

    const yearOptions = [{ value: '', label: 'Select year' }, ...['2022', '2023', '2024', '2025'].map((y) => ({ value: y, label: y }))];
    const monthOptions = [{ value: '', label: 'Select month' }, ...monthArray.map((m) => ({ value: m.id, label: m.name }))];
    const dayOptions = [{ value: '', label: 'Select days' }, ...dayArray.map((d) => ({ value: d, label: d }))];
    const canSubmit = !!(year && month && day && email);

    return (
        <Page>
            <PageHeader
                eyebrow="Teacher Operations"
                title="Teacher Compensation"
                subtitle="Email a compensation report for half a month."
            />

            <Card className="compensation-card">
                <form className="compensation-form" noValidate onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <Field label="Year" required>
                        {(ctl) => <Select {...ctl} name="year" options={yearOptions} value={year} onChange={handleSelectChange} />}
                    </Field>
                    <Field label="Month" required>
                        {(ctl) => <Select {...ctl} name="month" options={monthOptions} value={month} onChange={handleSelectChange} />}
                    </Field>
                    <Field label="Days" required hint={month ? undefined : 'Pick a month first.'}>
                        {(ctl) => <Select {...ctl} name="day" options={dayOptions} value={day} onChange={handleSelectChange} disabled={!month} />}
                    </Field>
                    <Field label="Send to email" required className="compensation-form__wide">
                        {(ctl) => (
                            <TextInput {...ctl} type="email" name="email" value={email} onChange={handleSelectChange} placeholder="name@artiumacademy.com" />
                        )}
                    </Field>
                    <div className="compensation-form__actions">
                        <Button variant="secondary" onClick={clearForm}>Clear</Button>
                        <Button variant="primary" type="submit" loading={disabledBtn} disabled={!canSubmit}>
                            Email report
                        </Button>
                    </div>
                </form>
            </Card>
        </Page>
    );
};

export default TeacherCompensationReport;
